export default "__VITE_ASSET__af9cfbc1__"